import {ROUND_TRIP} from "./consts";
import moment from "moment";

const SUGGESTIONS_ENDPOINT = 'flight-times/suggestions';
const AIRPORT_DATA_ENDPOINT = 'flight-times/get-airport-info';
const QUOTE_ENDPOINT = 'flight-times/get-cost';

const getSuggestions = async (keyword, signal) => {
  if (keyword) {
    const json = await fetch(
      SUGGESTIONS_ENDPOINT + `?keywords=${keyword}`,
      {
        signal: signal
      }
    )
      .then((response) => response.json());
    return json;
  }
  return [];
}

const getAirportData = async (keyword, signal) => {
  if (keyword) {
    const json = await fetch(
      AIRPORT_DATA_ENDPOINT + `?keywords=${keyword}`,
      {
        signal: signal
      }
    )
      .then((response) => response.json());
    return json;
  }
  return [];
}

const getQuote = async (from, to, tripType, airCraft, signal) => {

  const date = new Date();
  const m = moment(date);

  const legs = [];
  legs.push({
    departureAirportObj: {
      id: from.id
    },
    arrivalAirportObj: {
      id: to.id
    },
    departureDateUTC: m.add(30, 'd').format('YYYY-MM-DD'),
    fplType: 'N',
    pax: 1
  });
  if (tripType === ROUND_TRIP) {
    legs.push({
      departureAirportObj: {
        id: to.id
      },
      arrivalAirportObj: {
        id: from.id
      },
      departureDateUTC: m.add(1, 'd').format('YYYY-MM-DD'),
      fplType: 'N',
      pax: 1
    });
  }

  const data = {
    aircraft: airCraft,
    customer: {
      lastName: 'Customer',
      account: {
        name: 'Airsprint Demo Client'
      }
    },
    legs: legs,
    workflow: "PRIVATE"
  }



  const json = await fetch(
    QUOTE_ENDPOINT,
    {
      method: 'POST',
      signal: signal,
      body: JSON.stringify(data)
    }
  )
    .then((response) => response.json());
  return json;


}

const minutesToHours = (duration, times) => {
  if(duration!="Loading"){
    const total = duration * (times > 0? times : 1);
    const minutesRemainder = total % 60;
    const hours = (total - minutesRemainder) / 60;
    return hours + 'h ' + (minutesRemainder < 10 ? '0' + minutesRemainder : minutesRemainder) + 'm';
  }
  else{
    return "Loading..";
  }
}

export {
  getSuggestions,
  getQuote,
  getAirportData,
  minutesToHours
};
